import { useEffect, useState } from "react";
import { X, Save } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PvpRules, PveRules } from "@/components/deck/ModeRules";
import { SetsRules } from "@/components/deck/SetsRules";
import { HeroesRules } from "@/components/deck/HeroesRules";

const TABS = [["pvp", "Arena & Atlantis"], ["pve", "Historic & Tesla"], ["sets", "Gear sets"], ["heroes", "Heroes & scaling"]];

export const RulesPanel = ({ open, onClose }) => {
  const [rules, setRules] = useState(null);
  const [tab, setTab] = useState("heroes");
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open && !rules) api.get("/grading/rules").then((r) => setRules(r.data)).catch((e) => toast.error(errMsg(e))); }, [open, rules]);
  const update = (patch) => { setRules((r) => ({ ...r, ...patch })); setDirty(true); };
  const save = async () => {
    setBusy(true);
    try { await api.put("/grading/rules", rules); setDirty(false); toast.success("Grading rules saved. Use Recalculate on a card to apply them."); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const close = () => { if (!dirty || window.confirm("You have unsaved rule changes. Close anyway?")) onClose(); };

  if (!open) return null;
  return (
    <aside className="lg lg-inbox lg-intake" data-testid="rules-panel">
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <h3 style={{ fontSize: 18, margin: 0, marginRight: "auto" }}>Grading rules</h3>
        <button className="lg-btn sm" onClick={save} disabled={!dirty || busy} data-testid="rules-save"><Save size={13} />{busy ? "Saving…" : dirty ? "Save rules" : "Saved"}</button>
        <button className="lg-btn ghost sm" onClick={close} data-testid="rules-close"><X size={14} /></button>
      </div>
      <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 10 }}>These rules decide every gear grade. The AI only copies numbers from screenshots.</p>
      <div className="lg-tabs" style={{ margin: "6px 0 14px" }}>
        {TABS.map(([k, l]) => <button key={k} className={`lg-tab ${tab === k ? "on" : ""}`} onClick={() => setTab(k)} data-testid={`rules-tab-${k}`}>{l}</button>)}
      </div>
      {!rules && <p>Loading…</p>}
      {rules && tab === "pvp" && <PvpRules rules={rules} update={update} />}
      {rules && tab === "pve" && <PveRules rules={rules} update={update} />}
      {rules && tab === "sets" && <SetsRules rules={rules} update={update} />}
      {rules && tab === "heroes" && <HeroesRules rules={rules} update={update} />}
    </aside>
  );
};
